// extracted by mini-css-extract-plugin
var _1 = "FormFields-modulecheckboxLabel__Yqndc";
var _2 = "FormFields-modulecheckboxLabelTitle__SBdEh";
export { _1 as "checkboxLabel", _2 as "checkboxLabelTitle" }
